export default __webpack_public_path__ + "static/painting1-f6ee4224a493190943f1464e3b24355c.jpg";